export default __webpack_public_path__ + "static/media/11-69.fe658132.png";